import React from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from '../components/LocalizedLink';
import { SEO } from '../lib/seo';
import { getLangFromPath } from '../i18n/langs';

const TEXTS = {
  es: { title: 'Página no encontrada', text: 'La página que buscas no existe o se ha movido.', home: 'Volver al inicio', call: '¿Una urgencia eléctrica? Llama al' },
  ca: { title: 'Pàgina no trobada', text: 'La pàgina que busques no existeix o s\'ha mogut.', home: "Tornar a l'inici", call: 'Una urgència elèctrica? Truca al' },
  en: { title: 'Page not found', text: 'The page you are looking for does not exist or has been moved.', home: 'Back to home', call: 'Electrical emergency? Call' },
  fr: { title: 'Page introuvable', text: "La page que vous cherchez n'existe pas ou a été déplacée.", home: "Retour à l'accueil", call: 'Une urgence électrique ? Appelez le' },
};

const NotFound: React.FC = () => {
  const location = useLocation();
  const tx = TEXTS[getLangFromPath(location.pathname)];
  return (
    <>
      <SEO title={tx.title + ' | Electricista Urgencias 24h Barcelona'} description={tx.text} noindex />
      <div className="py-24">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-4">{tx.title}</h1>
          <p className="text-gray-600 mb-8">{tx.text}</p>
          <Link to="/" className="btn-primary inline-flex items-center justify-center">{tx.home}</Link>
          <p className="mt-8 text-gray-600">
            {tx.call} <a href="tel:+34600238283" className="text-yellow-600 font-semibold">+34 600 23 82 83</a>
          </p>
        </div>
      </div>
    </>
  );
};

export default NotFound;

